export let mailModuleName = "EysMke";
export default {mailModuleName};